import React from 'react'
import './Chat.scss'

const Chat = () => {
  return (
    <div>Chat</div>
  )
}

export default Chat